module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu1.c83ffe22.png";